import axios, { AxiosResponse } from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import { history } from 'routes/history';
import {
	TGetJotformsRequest,
	TJotform,
	TGetJotformRequest,
	TCreateEmerchantRequest,
	TCreateEmerchantResponse,
	TJotformListResponsePayload,
	TJotformWarning,
} from './types';
import {
	getJotformsRequest,
	getJotformsSuccess,
	getJotformRequest,
	getJotformSuccess,
	createEmerchantRequest,
	createEmerchantSuccess,
	createEmerchantWarning,
	jotformInitState,
} from './reducer';

export function* getJotformsRequestWorker(action: PayloadAction<TGetJotformsRequest>) {
	const { payload } = action;
	try {
		const response: TJotformListResponsePayload = yield call(api.jotform.getJotforms, payload);
		yield put(getJotformsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
	}
}

export function* getJotformRequestWorker(action: PayloadAction<TGetJotformRequest>) {
	const { payload } = action;
	try {
		const response: TJotform = yield call(api.jotform.getJotform, payload.id);
		yield put(getJotformSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
	}
}

export function* createEmerchantRequestWorker(action: PayloadAction<TCreateEmerchantRequest>) {
	const { payload } = action;
	try {
		const response: AxiosResponse<TCreateEmerchantResponse> = yield call(
			api.jotform.createEmerchant,
			payload,
		);
		if (response.status === 210) {
			notificationContainer(response.data?.message ?? 'Merchant created with warnings', 'warning');
			yield put(createEmerchantWarning(response.data as unknown as TJotformWarning));
		} else {
			yield put(createEmerchantSuccess(response.data));

			notificationContainer(response.data?.message ?? 'Merchant created successfully', 'success');
			history.push(`/em-management/${response.data.id}`);
		}
	} catch (error: any) {
		if (axios.isAxiosError(error)) {
			// yield put(jotformInitState());
			yield put(createEmerchantSuccess(null));

			notificationContainer(String(error.response?.data?.message ?? 'Error'), 'error');
		}
	}
}

export function* jotformSaga() {
	yield takeEvery(getJotformsRequest.type, getJotformsRequestWorker);
	yield takeEvery(getJotformRequest.type, getJotformRequestWorker);
	yield takeEvery(createEmerchantRequest.type, createEmerchantRequestWorker);
}
